import { createSlice } from '@reduxjs/toolkit'
import { strapiFetch, StrapiApiError } from '../../api/strapi'

const slice = createSlice({
    name: 'services',
    initialState: {
        data: null,
        loading: false,
        loaded: false,
        error: null,
        detail: null,
        detailLoading: false,
        detailError: null,
    },
    reducers: {
        setLoading: (state, action) => { state.loading = action.payload },
        setLoaded: (state, action) => { state.loaded = action.payload },
        setData: (state, action) => { state.data = action.payload },
        setError: (state, action) => { state.error = action.payload },
        setDetailLoading: (state, action) => { state.detailLoading = action.payload },
        setDetail: (state, action) => { state.detail = action.payload },
        setDetailError: (state, action) => { state.detailError = action.payload },
    },
})

export default slice.reducer

const { setLoading, setLoaded, setData, setError, setDetailLoading, setDetail, setDetailError } = slice.actions

const serviceListPopulate = {
    'populate[image]': 'true',
    'populate[file]': 'true',
    'pagination[pageSize]': 100,
}

const serviceDetailPopulate = {
    'populate[image]': 'true',
    'populate[file]': 'true',
    'populate[sliders][populate][image]': 'true',
}

export const loadServicesData = (locale) => async dispatch => {
    dispatch(setLoading(true))
    dispatch(setError(null))
    try {
        const [page, services] = await Promise.all([
            strapiFetch('/api/services-page', {
                locale,
                params: {
                    'populate[seo]': 'true',
                    'populate[bannerImage]': 'true',
                },
            }),
            strapiFetch('/api/services', { locale, params: serviceListPopulate }),
        ])
        dispatch(setData({ page: page.data, items: services.data }))
        dispatch(setLoaded(true))
    } catch (e) {
        dispatch(setError(e instanceof StrapiApiError ? e.message : 'Failed to load services page'))
    } finally {
        dispatch(setLoading(false))
    }
}

export const loadServiceBySlug = (slug, locale) => async dispatch => {
    dispatch(setDetailLoading(true))
    dispatch(setDetailError(null))
    try {
        const json = await strapiFetch('/api/services', {
            locale,
            params: { 'filters[slug][$eq]': slug, ...serviceDetailPopulate },
        })
        dispatch(setDetail(json.data[0] || null))
    } catch (e) {
        dispatch(setDetailError(e instanceof StrapiApiError ? e.message : 'Failed to load service'))
    } finally {
        dispatch(setDetailLoading(false))
    }
}
